var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[_c('div',{staticClass:"landing-container"},_vm._l((_vm.myJson),function(component){return _c(component,{key:component,tag:"component"})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }